import { render, staticRenderFns } from "./ApproveEdit.vue?vue&type=template&id=60445f83"
import script from "./ApproveEdit.js?vue&type=script&lang=js&external"
export * from "./ApproveEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports